import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router'
import { portalSessionQueryOptions } from '@/lib/portal-session'
import { isPortalSessionAuthorized } from '@/lib/portal-session-state'
import { AuthPage } from './-components/auth-page'
import {
	authSearchSchema,
	socialProvidersQueryOptions
} from './-lib/auth-route'

export const Route = createFileRoute('/register')({
	ssr: false,
	validateSearch: authSearchSchema,
	beforeLoad: async ({ context, search }) => {
		try {
			const session = await context.queryClient.fetchQuery(
				portalSessionQueryOptions()
			)
			if (isPortalSessionAuthorized(session)) {
				throw redirect({ to: search.redirect ?? '/dashboard' })
			}
		} catch (error) {
			if (isRedirect(error)) {
				throw error
			}
		}
	},
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(socialProvidersQueryOptions()),
	component: RegisterPage
})

function RegisterPage() {
	const search = Route.useSearch()

	return (
		<AuthPage
			mode='register'
			providers={Route.useLoaderData()}
			redirect={search.redirect}
			socialError={search.error !== undefined}
		/>
	)
}
